.vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--s-4);
  padding: var(--s-10) var(--s-8);
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-panel);
  background: var(--surface-sunken);
  font-family: var(--font-body);
}
.vacio[data-tone="dashed"] {
  border-style: dashed;
  border-color: var(--border-strong);
  background: transparent;
}
/* Adentro de otra superficie: sin marco, sin fondo, sin padding propio; el icono en violeta. */
.vacio[data-tone="plain"] {
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}
.vacio[data-tone="plain"] .icono {
  width: 44px;
  height: 44px;
  background: var(--surface-brand-faint);
  color: var(--text-brand);
}
.icono {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--s-11);
  height: var(--s-11);
  border-radius: var(--r-full);
  background: var(--surface-muted);
  color: var(--text-muted);
  margin-bottom: var(--s-2);
}
.titulo {
  margin: 0;
  font-family: var(--font-display);
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-heading);
  color: var(--text-strong);
}
.texto {
  max-width: 44ch;
  font-size: var(--fs-sm);
  line-height: var(--lh-relaxed);
  color: var(--text-muted);
}
.texto p {
  margin: 0;
}
.accion {
  margin-top: var(--s-3);
}
